import React from 'react';
import './SecondaryStringDisplay.scss';
import Slider from '@material-ui/core/Slider';
import { Curve } from 'curves';
import usePingPongAutoplay from '../../../../helpers/usePingPongAutoplay';

interface SecondaryStringDisplay {
    curve: React.RefObject<Curve<string>>;
    steps?: number;
}

function SecondaryStringDisplay(props: SecondaryStringDisplay): React.ReactElement {
  const curve = props.curve.current;

  const autoplay = usePingPongAutoplay({
    min: curve?.startTime ?? 0,
    max: curve?.endTime ?? 0,
  });

  if (!curve) return <div>No curve</div>;

  const duration = (curve.duration + curve.startTime);
  const stepTime = duration / (props.steps ?? 50);

  return (
    <div className="string-container">
      <div className="curve-string">
        {curve.evaluate(autoplay.value)}
      </div>
      <div className="time-slider-container">
        <h5>Adjust Time</h5>
        <br />
        <Slider
          value={autoplay.value}
          onChange={autoplay.handleChange}
          step={stepTime}
          min={curve.startTime}
          max={curve.endTime}
          marks={curve.keys.map((key) => ({
            value: key.time,
            label: key.value,
          }))}
        />
      </div>
    </div>
  );
}

export default SecondaryStringDisplay;
